import logo from './logo.svg';
import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import Work from './pages/work';
import Home from './pages/home';
import Endorsements from './pages/endorsements';
import Media from './pages/media';
import Kindle from './pages/kindle';


function App() {
  return (
    <Router>
      <div className="App">

        <nav className="horizontal-menu" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000 }}>
          <ul>
            <li style={{ display: 'flex' }}><a href='/'><span className='ann-header'>
              Ann Olivier</span></a></li>

            <li style={{ marginLeft: 'auto', marginTop: 3, display: 'flex' }}><a href="/">Home</a></li>
            <li style={{ marginTop: 3 }}><a href="/work">Work</a></li>
            <li style={{ marginTop: 3 }} ><a href="/endorsements">Endorsements</a></li>
            <li style={{ marginTop: 3 }} ><a href="/media">Media</a></li>
            <li style={{ marginTop: 3 }} ><a href="/kindle">On my Kindle</a></li>
            <li style={{ marginLeft: 'auto' }}>
              <a href="https://www.linkedin.com/in/annolivier" target="_blank" rel="noopener noreferrer">
                <FaLinkedin size={30} color="#0e76a8" />
              </a>
            </li>
          </ul>
        </nav>

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/work" element={<Work />} />
          <Route path="/endorsements" element={<Endorsements />} />
          <Route path="/media" element={<Media />} />
          <Route path="/kindle" element={<Kindle />} />
        </Routes>

        <footer className="App-footer">
          <div className="footer-content">
            <p>&copy; 2025 Ann Olivier. All rights reserved.</p>
          </div>
        </footer>
      </div>
    </Router >
  );
}

export default App;
